import { CookieBannerProps as NetlineCookieBannerProps } from '@lsy-netline/netline-ui/CookieBanner';
import { useTranslation } from 'react-i18next';

import { CookieBanner as NetLineCookieBanner } from 'netline-ui';

type CookieBannerProps = Partial<NetlineCookieBannerProps> & {
  enabled: boolean;
  items: NetlineCookieBannerProps['items'];
  mode: NetlineCookieBannerProps['mode'];
  open: NetlineCookieBannerProps['open'];
  onClose: NetlineCookieBannerProps['onClose'];
  cookiePolicyUrl?: string;
};

const CookieBanner = ({ enabled, items, mode, open, onClose, cookiePolicyUrl, ...props }: CookieBannerProps) => {
  const { t } = useTranslation();
  if (!enabled) {
    return null;
  }

  const privacy = cookiePolicyUrl
    ? {
        text: t('cookie.privacy.text'),
        url: cookiePolicyUrl,
      }
    : undefined;

  return (
    <NetLineCookieBanner
      open={open}
      onClose={onClose}
      mode={mode}
      items={items}
      title={t('cookie.title')}
      description={t('cookie.description')}
      acceptAllText={t('cookie.accept_all_text')}
      acceptCheckedText={t('cookie.accept_checked_text')}
      acceptText={t('cookie.accept_text')}
      cancelText={t('cookie.cancel_text')}
      saveText={t('cookie.save_text')}
      privacy={privacy}
      PaperProps={{
        sx: {
          margin: { xs: 1, sm: 'auto' },
        },
      }}
      {...props}
    />
  );
};

export default CookieBanner;
